<template>
  <div>
    <h1>
      User search
    </h1>
    <div class="card">
      <div class="card-header">User Search</div>
      <div class="card-body">
        <b-row>
          <b-col cols="4">
            <BaseTextInput label="Email" v-model="search.email" :v="$v.search.email"/>
          </b-col>
          <b-col cols="4">
            <BaseTextInput label="Last name" v-model="search.lastName" :v="$v.search.lastName"/>
          </b-col>
          <b-col cols="4">
            <BaseTextInput label="First name" v-model="search.firstName" :v="$v.search.firstName"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button variant="primary" class="mr-1r" @click="submit()">Search</b-button>
            <b-button variant="secondary" class="mr-1r" @click="clear()">Clear</b-button>
          </b-col>
        </b-row>
        <div v-if="submitted">
          <hr/>
          <p class="text-danger" v-if="results.length >= 100">For performance reasons, results are limited to 100 results. Consider narrowing your search.</p>
          <b-table hover small show-empty class="sr-caption"
                   aria-live="polite"
                   id="userTable"
                   responsive="true"
                   :fields="fields"
                   :items="results"
                   :busy="isLoading"
                   caption="User search table. Sorting is disabled due to manner of how users are retrieved from keycloak.">
            <template v-slot:no-data>
              No matching users found
            </template>
            <template v-slot:cell(actions)="row">
              <a :href="'/viewUser/'+row.item.idmId" target="_blank" class="btn btn-primary btn-sm">View</a>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import axios from "axios";

export default {
  name: "UserSearch",
  components: {BaseTextInput},
  data: ()=>({
    search: {
      email: null,
      firstName: null,
      lastName: null
    },
    results: [],
    submitted: false,
    isLoading: false,
    fields: [
      {key: 'email', label: 'Email'},
      {key: 'lastName', label: 'Last Name'},
      {key: 'firstName', label: 'First Name'},
      {key: 'actions', label: 'Actions'}
    ],
  }),
  methods:{
    submit(){
      this.submitted=true;
      this.isLoading=true;
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/users`, this.search)
          .then(response => {
            this.results=response.data;
            this.isLoading=false;
          })

    },
    clear(){
      this.search={
        email: null,
        lastName: null,
        firstName: null
      };
      this.isLoading=false;
      this.submitted=false;
    }
  },
  validations(){
    return{
      search:{
        email: {required: false},
        firstName: {required: false},
        lastName: {required: false}
      }
    }
  }

}
</script>

<style scoped>

</style>